/** Monetary snapshots without a scale predate native multi-currency quoting.
 * Keep their historical two-decimal meaning, including JPY and other currencies
 * whose current ISO scale differs. Never infer an old order's scale from ISO. */
export function orderCurrencyMinorDigits(record: Record<string, unknown> | null | undefined): number {
  const value = record?.currencyMinorDigits;
  return typeof value === "number" && Number.isInteger(value) && value >= 0 && value <= 6 ? value : 2;
}
